import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

// Badge styled-components that exactly match Tailwind CSS output
// Using the same CSS custom properties as defined in globals.css
export const BadgeContainer = styled.span.withConfig({
    shouldForwardProp: (prop) => !prop.startsWith('$'),
})<{
    $variant?: 'default' | 'secondary' | 'success' | 'warning' | 'error' | 'outline'
    $size?: 'small' | 'medium' | 'large'
}>`
    /* Base styles - exact match of Tailwind badge classes */
    display: inline-flex; /* inline-flex */
    align-items: center; /* items-center */
    justify-content: center; /* justify-center */
    border-radius: 0.375rem; /* rounded-md */
    border: 1px solid transparent; /* border - will be overridden by variants */
    padding-left: 0.5rem; /* px-2 */
    padding-right: 0.5rem;
    padding-top: 0.125rem; /* py-0.5 */
    padding-bottom: 0.125rem;
    ${getFontStyle('p03Medium')} /* 12px, 500 weight - matches text-xs font-medium */
    width: fit-content; /* w-fit */
    white-space: nowrap; /* whitespace-nowrap */
    flex-shrink: 0; /* shrink-0 */

    /* Size variants */
    ${(props) => {
        switch (props.$size) {
            case 'small':
                return `
                    padding-left: 0.375rem; /* px-1.5 */
                    padding-right: 0.375rem;
                    padding-top: 0; /* py-0 */
                    padding-bottom: 0;
                    ${getFontStyle('footBold')} /* 10px, 700 weight - closest match for tiny badge text */
                `
            case 'large':
                return `
                    padding-left: 0.75rem; /* px-3 */
                    padding-right: 0.75rem;
                    padding-top: 0.25rem; /* py-1 */
                    padding-bottom: 0.25rem;
                    ${getFontStyle('p02Medium')} /* 14px, 500 weight - matches text-sm font-medium */
                `
            default: // medium
                return `
                    /* Default size already set in base styles */
                `
        }
    }}

    /* Variant styles - using exact color values from Tailwind */
    ${(props) => {
        switch (props.$variant) {
            case 'secondary':
                // bg-secondary text-secondary-foreground
                return `
                    background-color: var(--secondary);
                    color: var(--secondary-foreground);
                    border-color: transparent;
                `
            case 'success':
                // bg-green-100 text-green-800
                return `
                    background-color: #dcfce7; /* bg-green-100 */
                    color: #166534; /* text-green-800 */
                    border-color: transparent;
                `
            case 'warning':
                // bg-yellow-100 text-yellow-800
                return `
                    background-color: #fef3c7; /* bg-yellow-100 */
                    color: #92400e; /* text-yellow-800 */
                    border-color: transparent;
                `
            case 'error':
                // bg-red-100 text-red-600
                return `
                    background-color: #fee2e2; /* bg-red-100 */
                    color: #dc2626; /* text-red-600 */
                    border-color: transparent;
                `
            case 'outline':
                // border bg-background
                return `
                    background-color: var(--background);
                    color: var(--foreground);
                    border-color: var(--border);
                `
            default:
                // bg-primary text-primary-foreground
                return `
                    background-color: var(--primary);
                    color: var(--primary-foreground);
                    border-color: transparent;
                `
        }
    }}
`
